<template>
  <div class="Table1Charts">
    <TableDateDownSelect
      v-if="value.isShowRightDropDownBox"
      :tabselectData="tabselectData"
      :pickerType="pickerType"
      :selectApi="selectApi"
      @tabSelectChange="tabSelectChange"
    >
    </TableDateDownSelect>
    <div class="table">
      <el-table :data="tableData" border style="width: 100%" ref="myTable">
        <!-- 
          设置表头数据源，并循环渲染出来，property对应列内容的字段名 
          v-if="item.flag" 判断列 是否展示 过滤器中 设置
        -->
        <template v-for="(item, index) in tableProps">
          <el-table-column
            :prop="item.prop"
            :key="index"
            :label="item.ChineseName"
            align="center"
            :width="cloumnWith(index, item)"
            :property="item.prop"
            v-if="item.flag"
          >
            <!-- 数据的遍历 scope 就代表数据的每一个对象-->
            <template v-slot="scope">
              <!-- 判断是否有 user_url -->
              <div v-if="scope.row.user_url">
                <a class="row_user_url" :href="scope.row.user_url" target="_blank">{{
                  scope.row[scope.column.property]
                }}</a>
              </div>
              <div v-else>
                <span>{{ scope.row[scope.column.property] }}</span>
              </div>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <!-- <div class="no-data" v-if="noData">
      <sapn>暂无数据！</sapn>
    </div> -->
  </div>
</template>

<script>
import { request } from '../../../../common/request';
import { getFilterValue } from '../../../../utils/tool';
import TableDateDownSelect from '@/components/common/TableDateDownSelect/TableDateDownSelect.vue';

export default {
  name: 'Table1Charts',
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  components: { TableDateDownSelect },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      value: {
        isShowRightDropDownBox: false,
      },
      tabselectData: [], // 下拉选择的时间数据d
      params: {}, // 请求参数
      paramsCopy: {},
      noData: false, // 无数据
      tabShow: true,

      loading: true,
      // 表格数据
      tableData: [],
      selectApi: '',
      tableProps: [], // 表格属性
      // 表格跳转数据
      value: {
        isShowRightDropDownBox: false,
      },
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.getApiDataResByFilterAndResponseQuery();

    // 默认取api参数
    let that = this;
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;

    // 判断 数据 为本地或动态
    this.selectApi = ChartsData;
    let params = ChartsData?.apiData?.apiPostParams || '{}';
    console.log(params, 'params params');
    this.params = eval('(' + params + ')');
    this.paramsCopy = eval('(' + params + ')');
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.unRegisterDebounceAndThrottle();
  },
  methods: {
    tabSelectChange(e) {
      console.log('改变,,,,,,', e);
      // 判断是否使用静态数据
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      if (ChartsData?.currenEntry === 'staticData') {
        this.echartsClick = e;
      } else {
        this.params = this.getFilterValue(e);
        this.startApiIntervalTask();
      }
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    cloumnWith(index, item) {
      if (item.prop === 'time' && index == 0) {
        return 100;
      }
    },
    getFilterValue(e) {
      return getFilterValue(e);
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      let grid = {};
      let color = [];
      let source = [];
      let seriesList = [];
      let tableDownData = [];

      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };
      let tableProps = [];

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        color = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;

        seriesList = ParamData.seriesList;
        tableProps = ParamData?.tableProps; // 表格数据需要的
        tableDownData = ParamData?.tableDownData; // 表格数据需要的

        if (tableProps) {
          this.tableProps = tableProps;
        }
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }
      if (this.Configuration.propertyData?.chartsRightDropDown?.value) {
        this.value = this.Configuration.propertyData.chartsRightDropDown.value;
      }

      // 时间
      let that = this;
      function dealSelectData() {
        let tabselectData = [];
        let pickerType = [];
        if (tableDownData) {
          tableDownData.forEach(item_t => {
            tabselectData.push(
              item_t[0], //  tabMont  tabYear
            );
            pickerType.push(item_t[1]);
          });
        }

        that.tabselectData = tabselectData;
        that.pickerType = pickerType;
      }
      if (this.value.isShowRightDropDownBox) {
        dealSelectData();
      }

      let props = []; // 表格遍历需要的prop以及对应的name
      let tableData = []; // 数据
      function DealData() {
        seriesList.forEach(s => {
          // id
          let obj = {};
          tableProps.forEach(tab => {
            // 表头
            source.forEach(item => {
              if (tab.prop === item.x && s === item.s) {
                obj[tab.prop] = item.y;
              }
            });
          });
          tableData.push(obj);
        });
      }
      DealData();
      // console.log(this.tableData, 'this.tableData');
      // tableData.forEach(item => {
      //   item.abc = parseInt(Math.random() * 6);
      // });

      this.tableData = tableData;

      // 关闭加载
      this.$nextTick(() => {
        this.loading = false;
        // console.log('关闭加载', this.loading.close);
      });
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          this.setEchartsOptions(ChartsData.staticData);
          this.$nextTick(() => {
            // this.createEcharts();
          });
        };
        func();
        this.staticIntervalTaskID = setInterval(() => {
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
        // console.log(ChartsData.staticData);
        this.$nextTick(() => {
          // this.createEcharts();
        });
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: that.params,
            headers: header,
          };
          request(param)
            .then(res => {
              let data = that.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          let params = ChartsData.apiData.apiPostParams || {};
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: that.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = that.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            console.log('getApiDataResByResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            console.log('getApiDataResByFilterAndResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },

  Configuration: {
    componentTitle: '基础表格',
    componentName: 'Table1Charts',
    componentOverViewImg: './img/charts/TableCharts/Table1Charts.png',
    id: '',
    style: {
      width: 400,
      height: 200,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            isUseInterval: true,
            apiInterval: 10,
            apiUrlMethod: 'get',
            apiPostParams: '',
          },
          staticData: {
            seriesList: ['1', '2'],
            tableProps: [
              {
                prop: 'time',
                ChineseName: '时间',
                flag: true,
              },
              {
                prop: 'typename',
                ChineseName: '来源',
                flag: true,
              },
              {
                prop: 'salesquantity',
                ChineseName: '城市',
                flag: true,
              },
              {
                prop: 'acceptedtotal',
                ChineseName: '评价',
                flag: true,
              },
            ],
            source: [
              {
                s: '1',
                x: 'time',
                y: '1',
              },
              {
                s: '1',
                x: 'typename',
                y: '销售',
              },
              {
                s: '1',
                x: 'salesquantity',
                y: '5421',
              },
              {
                s: '1',
                x: 'acceptedtotal',
                y: '5421',
              },

              {
                s: '2',
                x: 'time',
                y: '2',
              },
              {
                s: '2',
                x: 'typename',
                y: '电商',
              },
              {
                s: '2',
                x: 'salesquantity',
                y: '3664',
              },
              {
                s: '2',
                x: 'acceptedtotal',
                y: '5421',
              },
            ],
          },
          // staticData: {
          //   seriesList: ['1', '2'],
          //   tableProps: [
          //     {
          //       prop: 'phone',
          //       ChineseName: '排名',
          //       flag: true,
          //     },
          //     {
          //       prop: 'name',
          //       ChineseName: '标题',
          //       flag: true,
          //     },
          //   ],
          //   source: [
          //     {
          //       s: '1',
          //       x: 'name',
          //       y: '事件1',
          //     },
          //     {
          //       s: '1',
          //       x: 'phone',
          //       y: '1',
          //     },
          //     {
          //       s: '2',
          //       x: 'name',
          //       y: '事件2',
          //     },

          //     {
          //       s: '2',
          //       x: 'phone',
          //       y: '2',
          //     },
          //   ],
          // },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 10,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '5%',
          bottom: '17%',
          top: '12%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsRightDropDown: {
        propertyComponentName: 'ChartsRightDropDownConfiger',
        value: {
          isShowRightDropDownBox: false,
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.Table1Charts {
  color: white;
  width: 100%;
  height: 100%;
  .table {
    height: auto;
    max-height: 100%;
    /* overflow: scroll; */
    overflow: scroll;
    /* max-width: 800px; */
    border: 1px solid #08e5ed;
    border-radius: 4px;
    background: url('../../../../assets/img/splbg.png') no-repeat;
    background-size: 100% 100%;
  }

  /* position: relative; */
  .echarts {
    width: 100%;
    height: 100%;
  }
  .no-data {
    width: 100%;
    height: 100%;
    // background: #000;
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #ccc;
  }
  :deep().el-loading-spinner {
    .path {
      stroke: #fff !important;
    }

    p {
      display: flex !important;
      align-items: center !important;
      color: #fff !important;
    }
  }
  .row_user_url {
    color: #08e5ed;
    text-decoration: none;
  }
  .TableDateDownSelect {
    position: absolute;
    top: -8px;
    right: 4px;
  }
}
:deep().el-table {
  background: none;
  color: #08e5ed !important;
  // border: 1px solid #08e5ed;
}
:deep().el-table th {
  background: none;
}

::v-deep .el-table__body-wrapper {
  height: calc(100% - 0.48rem) !important;
  overflow: auto;
  overflow-y: scroll;
  overflow-x: hidden;
}

:deep(.el-table tr) {
  background: none;
}
:deep(.el-table thead) {
  color: #08e5ed;
}

:deep().el-table td,
.el-table th.is-leaf,
.el-table--border,
.el-table--group {
  border-color: black;
}
:deep().el-table--border::after,
.el-table--group::after,
.el-table::before {
  background-color: black;
}
// table边框颜色
:deep().el-table--border:after,
.el-table--group:after,
.el-table:before {
  background-color: #58a5e7;
}

:deep().el-table--border,
.el-table--group {
  border-color: #58a5e7;
}

:deep().el-table td,
.el-table th.is-leaf {
  border-bottom: 1px solid #58a5e7;
  // border-left: 1px solid #58a5e7;
}

:deep().el-table--border th,
.el-table--border th.gutter:last-of-type {
  border-bottom: 1px solid #58a5e7;
}

:deep().el-table--border td,
.el-table--border th {
  border-right: 1px solid #58a5e7;
  padding: 6px 0;
}
:deep().el-table--border th,
.el-table--border td {
  border-right: 1px solid #58a5e7;
}
:deep()tbody tr:hover > td {
  background-color: #66b1ff;
}
:deep()tbody tr.hover-row > td {
  background-color: #66b1ff;
}
:deep().el-table {
  tbody tr:hover > td {
    background-color: #414141;
  }
}
/* // 滚动条的宽度 */
:deep() .el-table__body-wrapper::-webkit-scrollbar {
  /* // 横向滚动条 */
  width: 6px;
  /* // 纵向滚动条 必写 */
  height: 4px;
}
/* // 滚动条的滑块 */
:deep() .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #8f8f8fd3;
  border-radius: 3px;
}

::-webkit-scrollbar {
  width: 0px;
  height: 2px;
  background-color: none;
}
::-webkit-scrollbar-thumb {
  border-radius: 2px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #5ec7da75;
  border-radius: 3px;
}
@media screen and (max-width: 800px) {
  ::v-deep.el-table {
    th.gutter colgroup.gutter {
      display: block !important;
      width: 6px !important;
    }
  }

  ::-webkit-scrollbar {
    width: 6px;
  }
  ::v-deep .el-table__body-wrapper {
    overflow-x: scroll !important;
    overflow-y: hidden !important;
  }
}
@media screen and (min-width: 3300px) {
  :deep().el-table--border th,
  .el-table--border td {
    line-height: 3 !important;
    font-size: 24px !important;
  }
  :deep().el-table--border td,
  .el-table--border th {
    padding: 14px 0 !important;
    font-size: 24px !important;
  }
}
</style>
